InsertModal = require 'components/etd/insert_modal'
useTranslation = require 'components/hooks/use_translation'
{ insertGdtTable } = require 'lib/epiditor_utils'
{ useState } = React
{ PMView } = Epiditor

GdtTableInsertControl = ({ additionalOptions, view, onCloseMenu }) ->
  i18n = useTranslation('')
  [isModalOpen, setIsModalOpen] = useState(false)
  canInsert = insertGdtTable(view.state)({})

  closeModal = ->
    setIsModalOpen false
    onCloseMenu()

  handleInsert = (insertData) ->
    { contentType, content } = insertData
    return unless contentType is 'GDT_TABLE'

    view.focus()
    insertGdtTable(view.state, view.dispatch)(content)
    closeModal()

  handleClick = (evt) ->
    evt.preventDefault()
    evt.stopPropagation()
    setIsModalOpen true

  <div>
    <div
      className={classNames 'gdt-table-insert-toggle', disabled: !canInsert}
      onMouseDown={handleClick if canInsert}
    >
      <span>{i18n 'actions.insert_sof_table'}</span>
    </div>
    {isModalOpen and
      <InsertModal
        additionalOptions={additionalOptions}
        forceGdtTableContent
        includeCommonOptions={false}
        onClose={closeModal}
        onInsert={handleInsert}
        title={i18n 'es:recommendations.insert_modal.sof_table'}
      />
    }
  </div>

GdtTableInsertControl.propTypes =
  additionalOptions: PropTypes.object
  view: PropTypes.instanceOf(PMView.EditorView).isRequired

module.exports = GdtTableInsertControl
